<template>
  <div class="TkIntelPolicyDetail">
    <ld-header>详情</ld-header>

    <mescroll-vue
      ref="mescroll"
      :down="{}"
    >
      <div class="wrapper">
        <div class="policy-item">
          <h3 class="policy-title">
            {{ policy.title }}
          </h3>

          <p class="policy-label">
            {{ policy.fbr }}
            <time class="gray">{{ policy.fbsj }}</time>
          </p>

          <div
            class="policy-content"
            v-html="policy.content"
          />
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
export default {
  name: 'TkIntelPolicyDetail',
  components: {
    MescrollVue: () => import('mescroll.js/mescroll.vue')
  },
  data () {
    return {
      policy: {}
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      const { data = {} } = await this.$api['common/policyDetail']({ id: this.id })
      this.policy = data
    }
  }
}
</script>

<style lang="less">
.TkIntelPolicyDetail {

  .wrapper {
    height: calc(100vh - 50px);
  }

  .policy-item {
    padding: 10px 20px;
    background-color: @color-background-white;
  }

  .policy-label {
    margin-top: 5px;
    font-size: @font-size-12;

    time {
      margin-left: 10px;
    }
  }

  .policy-content {
    padding: 10px;

    img {
      width: 100%;
    }
  }

}
</style>